import { FC } from "react";
import { BeatLoader } from "react-spinners";

interface LoadingScreenProps {
  children?: React.ReactNode;
  isLoding?: boolean;
  size?: number;
}

const LoadingScreen: FC<LoadingScreenProps> = ({
  children,
  isLoding = true,
  size = 25,
}) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen font-bold gap-7 text-2xxl text-interactive-light-teal">
      <BeatLoader
        color="#005159"
        loading={isLoding}
        size={size}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
      {children}
    </div>
  );
};

export default LoadingScreen;
